import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ShieldAlert, FileUp } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// App-wide banner for members whose ownership application is still pending.
// They keep full member access meanwhile; the banner nudges proof upload.
const PendingProofBanner = ({ onOpenVerify }) => {
  const { user } = useAuth();
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (!user || user.role === 'admin' || user.role === 'developer') { setPending(null); return; }
    axios.get(`${API}/api/memberships/me`)
      .then((r) => setPending((r.data.memberships || []).find((m) => m.status === 'pending') || null))
      .catch(() => {});
  }, [user]);

  if (!pending) return null;
  const needsProof = pending.proof_pending || pending.proof_status === 'missing' || pending.proof_status === 'rejected' || !(pending.proof_urls || []).length;

  return (
    <div className="container mx-auto px-4 mt-4 max-w-6xl" data-testid="pending-proof-banner">
      <div className="flex items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/30 px-4 py-3">
        {needsProof ? <FileUp className="h-5 w-5 text-amber-600 shrink-0" /> : <ShieldAlert className="h-5 w-5 text-amber-600 shrink-0" />}
        <p className="text-sm flex-1">
          {needsProof ? (
            <><b>Ownership verification pending:</b> you have full access meanwhile — upload your proof (allotment letter, agreement first page, or Index II) for <b>{pending.project_name}</b> to complete verification.</>
          ) : (
            <><b>Verification under review:</b> your proof for <b>{pending.project_name}</b> is with our team. You have full access meanwhile.</>
          )}
          {pending.proof_status === 'rejected' && pending.proof_rejection_reason && (
            <span className="block text-xs text-rose-700 mt-0.5">{pending.proof_rejection_reason}</span>
          )}
        </p>
        {needsProof && (
          <Button size="sm" className="bg-amber-600 hover:bg-amber-700 text-white shrink-0" onClick={onOpenVerify} data-testid="pending-proof-cta">
            Upload proof
          </Button>
        )}
      </div>
    </div>
  );
};

export default PendingProofBanner;
